import { render, staticRenderFns } from "./WeightPackingForm.vue?vue&type=template&id=538be8b8"
import script from "./WeightPackingForm.vue?vue&type=script&lang=js"
export * from "./WeightPackingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports